import { FunctionComponent, HTMLAttributes } from 'react';

const IconCheckPicker: FunctionComponent<HTMLAttributes<HTMLOrSVGElement>> = (
  props
) => (
  <svg
    {...props}
    width="14"
    height="12"
    viewBox="0 0 14 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.8161 0.180437C13.1418 0.453979 13.184 0.939716 12.9105 1.26536L4.82493 10.891C4.68157 11.0617 4.4713 11.1619 4.24844 11.1657C4.02559 11.1695 3.81202 11.0765 3.66292 10.9109L0.197683 7.0606C-0.0868191 6.74448 -0.0611931 6.25759 0.254921 5.97309C0.571035 5.68858 1.05793 5.71421 1.34243 6.03032L4.21525 9.22234L11.7312 0.274778C12.0047 -0.0508667 12.4905 -0.0931047 12.8161 0.180437Z"
      fill="white"
    />
  </svg>
);

export default IconCheckPicker;
